import React, { Fragment } from 'react';
import Panel from '../../../../../components/outline/Panel';
import InputForm from '../../../../../components/form/InputForm';
import BaseForm from '../../../../../components/form/BaseForm';
import ImgUpload from '../../../../../components/ImgUpload';
import SelectForm from '../../../../../components/form/SelectForm';
import SwitchForm from '../../../../../components/form/SwitchForm';
import Table from '../../../../../components/_table/Table';
import { MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_HOLDER_TEXT } from '../../../../../constants/service/app/balanceConstants';
import {
  BRAND_DETAIL_PAGE_PANEL_NAME,
  MAXIMUM_NUMBER_OF_STORE_ATTACHMENT,
} from '../../../../../constants/service/app/brandConstants';
import { REX_ACCOUNT_HOLDER, REX_NUMBER } from '../../../../../lib/rex';
import { formRequiredRules } from '../../../../../lib/formRules';
import columns from './columns';
import BrandDetailInfoBalancePeriodInfo from '../../../common/BrandDetailInfoBalancePeriodInfo';
import './BrandDetailInfoBalance.scss';

const BrandDetailInfoBalance = (props) => {
  const { data, setData, form, isEditable } = props;
  const {
    accountHolder,
    bankId,
    bankSelectList,
    accountNumber,
    bankBookCopyImg,
    storeEmail,
    balancePeriodInfoList,
    brandFeeInfoList,
    enabledFulfillment,
    amondzFeeInfoList,
  } = data;

  return (
    <Panel name={BRAND_DETAIL_PAGE_PANEL_NAME.BALANCE} className="brand-detail-info-balance">
      <div className="panel-header">
        <div className="title">정산 정보</div>
      </div>

      <div className="panel-body">
        {/*통장사본 이미지*/}
        <BaseForm
          label="통장사본 이미지"
          content={
            <ImgUpload
              list={bankBookCopyImg}
              modalTitle="통장사본 이미지"
              maxCnt={MAXIMUM_NUMBER_OF_STORE_ATTACHMENT}
              minCnt={MAXIMUM_NUMBER_OF_STORE_ATTACHMENT}
              setData={setData}
              targetPath={['brandDetail', 'info', 'balanceInfo', 'bankBookCopyImg']}
              isEditable={isEditable}
              cropMode={false}
            />
          }
        />

        {/* 은행 */}
        <SelectForm
          label="은행"
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, '필수사항 입니다.', false)]}
          initialValue={bankId}
          list={bankSelectList}
          onChange={(value) => setData({ path: ['brandDetail', 'info', 'balanceInfo', 'bankId'], value })}
          name="bankId"
        />

        {/* 예금주 */}
        <InputForm
          label="예금주"
          form={form}
          isEditable={isEditable}
          rules={[
            formRequiredRules(true, '필수사항 입니다.'),
            { pattern: REX_ACCOUNT_HOLDER, message: '예금주명은 한글, 영문, (),.! 만 입력 가능합니다.' },
          ]}
          initialValue={accountHolder}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', 'accountHolder'],
              value,
            })
          }
          maxLength={MAXIMUM_NUMBER_OF_BALANCE_ACCOUNT_ACCOUNT_HOLDER_TEXT}
          name="accountHolder"
        />

        {/* 계좌번호 */}
        <InputForm
          label="계좌번호"
          form={form}
          isEditable={isEditable}
          rules={[
            formRequiredRules(true, '필수사항 입니다.'),
            { pattern: REX_NUMBER, message: '계좌번호를 확인해주세요.' },
          ]}
          initialValue={accountNumber}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', 'accountNumber'],
              value,
            })
          }
          name="accountNumber"
        />

        {/* 전자세금계산서 이메일 */}
        <InputForm
          label="전자세금계산서 이메일"
          form={form}
          isEditable={isEditable}
          rules={[{ type: 'email', message: '전자세금계산서 이메일을 확인해주세요.' }]}
          initialValue={storeEmail}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'balanceInfo', 'storeEmail'],
              value,
            })
          }
          name="storeEmail"
        />

        {/* 정산주기 설정 */}
        <BaseForm
          className="fee-info"
          label="정산주기 설정"
          content={
            <BrandDetailInfoBalancePeriodInfo
              form={form}
              isEditable={isEditable}
              enabledFulfillment={enabledFulfillment}
              balancePeriodInfoList={balancePeriodInfoList}
              setData={(data) =>
                setData({
                  path: ['brandDetail', 'info', 'balanceInfo', 'balancePeriodInfoList', ...data.path],
                  value: data.value,
                })
              }
            />
          }
        />

        {/* 수수료 설정 */}
        <BaseForm
          className="fee-set-area"
          label="수수료 설정"
          content={
            <Fragment>
              <div className="management-type-fee-area">
                <div className="title">
                  <span className="management">관리처</span>
                  <span>브랜드</span>
                </div>
                <Table
                  columns={() =>
                    columns({
                      form,
                      isEditable,
                      listName: 'brandFeeInfoList',
                      setData,
                    })
                  }
                  rowKey={(record) => record.id}
                  list={brandFeeInfoList}
                  scroll={{ x: true }}
                  bordered={true}
                  showPagination={false}
                />
              </div>
              <div className="management-type-fee-area">
                <SwitchForm
                  className="fee-type-toggle"
                  label="풀필먼트 판매"
                  checked={enabledFulfillment}
                  disabled={!isEditable}
                  onChange={(value) =>
                    setData({
                      path: ['brandDetail', 'info', 'balanceInfo'],
                      value: {
                        ...data,
                        enabledFulfillment: value,
                      },
                    })
                  }
                />
                {enabledFulfillment ? (
                  <Fragment>
                    <div className="title">
                      <span className="management">관리처</span>
                      <span>아몬즈</span>
                    </div>
                    <Table
                      columns={() =>
                        columns({
                          form,
                          isEditable,
                          listName: 'amondzFeeInfoList',
                          setData,
                        })
                      }
                      rowKey={(record) => record.id}
                      list={amondzFeeInfoList}
                      scroll={{ x: true }}
                      bordered={true}
                      showPagination={false}
                    />
                  </Fragment>
                ) : null}
              </div>
            </Fragment>
          }
        />
      </div>
    </Panel>
  );
};

export default BrandDetailInfoBalance;
